import { SingleFilterButton } from '@backrs_ui/grow-ui/src/pages/Search/components/SingleFilterButton';

import { Box, SxProps, Theme } from '@mui/material';

type ProsperSubHeaderProps = Readonly<{
  isAllCategoriesSelected: boolean;
  selectedCategories: string[];
  onToggleAllCategories: () => void;
  onToggleCategory: (categorySlug: string) => void;
}>;

export const ProsperSubHeader = ({
  isAllCategoriesSelected,
  selectedCategories,
  onToggleAllCategories,
  onToggleCategory,
}: ProsperSubHeaderProps) => {
  return (
    <Box sx={subHeaderSx}>
      <Box sx={allUnlocksContainerSx}>
        <SingleFilterButton
          name="All Unlocks"
          iconName="FilterLines"
          isSelected={isAllCategoriesSelected || selectedCategories.length === 0}
          toggleFilter={onToggleAllCategories}
        />
      </Box>
      <Box sx={individualFilterGroupContainerSx}>
        <SingleFilterButton
          name="Academics"
          iconName="GraduationHat02"
          isSelected={selectedCategories.includes('academic-foundations')}
          toggleFilter={() => onToggleCategory('academic-foundations')}
        />
        <SingleFilterButton
          name="Achievement"
          iconName="Trophy01"
          isSelected={selectedCategories.includes('real-world-experience')}
          toggleFilter={() => onToggleCategory('real-world-experience')}
        />
        <SingleFilterButton
          name="Skills"
          iconName="Tool02"
          isSelected={selectedCategories.includes('mindsets-and-skills')}
          toggleFilter={() => onToggleCategory('mindsets-and-skills')}
        />
        <SingleFilterButton
          name="Communities"
          iconName="Server06"
          isSelected={selectedCategories.includes('community-of-success')}
          toggleFilter={() => onToggleCategory('community-of-success')}
        />
      </Box>
    </Box>
  );
};

const subHeaderSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: backrs.spacing['spacing-4xl'],
  justifyContent: 'space-between',
  my: backrs.spacing['spacing-sm'],
});

const allUnlocksContainerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: backrs.spacing['spacing-md'],
});

const individualFilterGroupContainerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: backrs.spacing['spacing-sm'],
  '@container (min-width: 600px)': {
    gap: backrs.spacing['spacing-lg'],
  },
  flexWrap: 'wrap',
});
